import React, { useEffect, useState } from 'react'
import BrandListItem from './BrandListItem'
import styles from './BrandsPanel.module.scss'

function BrandsArchiveSection({
  brands,
  activeId,
  onBrandClick,
  showInactiveReason,
  showProductsCount,
  defaultExpanded = false,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  useEffect(() => {
    if (defaultExpanded) {
      setIsExpanded(true)
    }
  }, [defaultExpanded])

  if (!brands.length) {
    return null
  }

  return (
    <div className={styles.archiveSection}>
      <button
        type="button"
        className={styles.archiveToggle}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        Архів ({brands.length})
        <span className={isExpanded ? styles.archiveChevronExpanded : styles.archiveChevron}>
          ▾
        </span>
      </button>

      {isExpanded && (
        <div className={styles.archiveList}>
          {brands.map((brand) => (
            <BrandListItem
              key={brand.id}
              brand={brand}
              activeId={activeId}
              onClick={onBrandClick}
              showInactiveReason={showInactiveReason}
              showProductsCount={showProductsCount}
              isHiddenItem
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default BrandsArchiveSection
